import { faPlus, faTags } from "@fortawesome/free-solid-svg-icons";
import Page from "components/common/page/Page";
import PersonDatalist from "components/entities/app/person/PersonDatalist";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const PersonDatalistPage = () => {
    const context = useAppContext();

    const link = {
        url: AppRoutes.PERSON_VIEW,
        params: (i: any) => ({ id: i.id })
    }

    const pageActions = [
        {
            icon: faTags,
            link: AppRoutes.PERSON_TAG_DATALIST,
            name: 'tags', 
            title: context.t('pages.people.tag.list')
        },
        {
            icon: faPlus,
            link: AppRoutes.PERSON_FORM, 
            hide: !context.userHasRole(Roles.PERSON_WRITE), 
            name: 'edit', 
            title: context.t('button.edit')
        }
    ];

    return (
        <Page title="pages.people.list" wFull actions={pageActions}>
            <PersonDatalist
                name="person-datalist-page"
                onItemClick={{ link }}
            />
        </Page>
    );
}

export default PersonDatalistPage;
